import styled from 'styled-components';

export const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;

`;

export const VideoContainer = styled.div`
  position: relative;
  width: 100%;
  height: 95px;
  border-radius: 6px;
  overflow: hidden;
  cursor: pointer;

  &:hover .overlay {
    opacity: 0.5; /* Make overlay visible */
  }

  &:hover .play-icon {
    opacity: 1; /* Make play icon visible */
  }
`;

export const Video = styled.video`
  width: 100%;
  height: 100%;
  border-radius: 6px;
  object-fit: cover;
  transition: transform 0.3s ease;

  &:hover {
    transform: scale(1.05); /* Slight zoom effect */
  }
`;

export const Overlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Dark overlay with 50% opacity */
  opacity: 0; /* Initially hidden */
  transition: opacity 0.3s ease;

  /* Make the overlay visible on hover */
  ${VideoContainer}:hover & {
    opacity: 1;
  }
`;

export const PlayIcon = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 30px;
  color: white;
  opacity: 0; /* Initially hidden */
  transition: opacity 0.3s ease;

  &:before {
    content: '▶'; /* Unicode character for play icon */
    font-weight: bold;
  }
`;
